export default __webpack_public_path__ + "static/media/pic10.b3261de9.jpg";